import { render } from "./ImportCardsView.vue?vue&type=template&id=24511368&scoped=true"
import script from "./ImportCardsView.vue?vue&type=script&lang=js"
export * from "./ImportCardsView.vue?vue&type=script&lang=js"

import "./ImportCardsView.vue?vue&type=style&index=0&id=24511368&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24511368"]])

export default __exports__